import Agende from "../";

const routes = [
    { name: "AgendeListPage", path: "/agende", component: Agende.AgendeListPage, meta: { title: "agende.lblTitle" } },
    { name: "AgendaEditPage", path: "/agende/edit/:id", component: Agende.AgendaEditPage, meta: { title: "agende.lblTitle" } },
    { name: "AgendaView", path: "/agende/view/:id", component: Agende.AgendaViewPage, meta: { title: "agende.lblTitle" } },
];

export default routes;
